import React, { FC, useCallback } from 'react'
import { generatePath, match } from 'react-router'

import CustomPopup from '../UI/Popup'
import CustomButton from '../UI/Buttons/CustomButton'

import SearchByProjects from './SearchByProjects'

import DefaultProject from '../../assets/img/example/project.png'
import { Can } from '../../CASL/Can'
import SignoutIcon from '../UI/Icons/SignOut'
import { AUTH_ROUTE } from '../../pages/App/routes'
import { TProject } from '../../store/project/types'
import { TUser } from '../../models'

import Roles from '../../models/roles'
import SettingsIcon from '../UI/Icons/Settings'
import CardIcon from '../UI/Icons/Card'
import EditIcon from '../UI/Icons/Edit'
import LoadableImage, { LOADER_STYLE } from '../UI/LoadableImage'
import SupportButton from '../SupportButton'

// type SwitchCustomerProps = {}
type SwitchCustomerProps = {
  user: TUser | null
  projects: TProject[]
  agency: any
  changeProject: (data: TProject) => void
  billing: () => void
  signout: () => void
  openEditProfileModal: () => void
  openAddProjectModal: () => void
  isActiveRoute: (path: string) => match<{}> | null
  moveTo: (path: string) => void
  currentProject: TProject | null
}

const SwitchCustomer: FC<SwitchCustomerProps> = ({
  projects,
  changeProject,
  agency,
  billing,
  signout,
  isActiveRoute,
  user,
  openAddProjectModal,
  openEditProfileModal,
  moveTo,
  currentProject
}) => {
  const popupTriggerUserActionsButtonsProject = useCallback(
    () => (
      <div key={`agancy2`} className='project-navigation__company-action__logo'>
        <LoadableImage
          media={currentProject?.logo_image_link || DefaultProject}
          loaderStyle={LOADER_STYLE.DARK}
        />
      </div>
    ),
    [currentProject]
  )

  return (
    <div className='project-navigation'>
      <div className='project-navigation__search'>
        <SearchByProjects />
      </div>
      <div className='project-navigation__change-customer'>
        {projects &&
          projects.map((project: TProject) => (
            <div
              key={`customer${project.id}`}
              onClick={() => changeProject(project)}
              className={`project-navigation__change-customer__item-wrapper`}
              title={project.name}
            >
              <div
                className={`project-navigation__change-customer__item-wrapper__item  ${
                  isActiveRoute(`/${project.id}/*`) ? 'active' : ''
                }`}
              >
                <div className='item-backdrop'></div>
                <LoadableImage
                  media={project.logo_image_link ? project.logo_image_link : DefaultProject}
                  loaderStyle={
                    isActiveRoute(`/${project.id}/*`) ? LOADER_STYLE.LIGHT : LOADER_STYLE.DARK
                  }
                />
              </div>
            </div>
          ))}
      </div>
      <div className='project-navigation__change-customer__placeholder'>
        {/* here */}
        <Can I='create' a='Project'>
          <div
            className='project-navigation__change-customer__placeholder__add-project'
            onClick={openAddProjectModal}
          ></div>
        </Can>
      </div>
      <div className='project-navigation__company-action'>
        <SupportButton />
        <CustomPopup
          isOpen={true}
          className='user-actions'
          position='right bottom'
          updateTrigger={user?.avatar_image_link}
          trigger={() => (
            <div className='project-navigation__company-action__avatar'>
              {user?.avatar_image_link ? (
                <LoadableImage media={user?.avatar_image_link} loaderStyle={LOADER_STYLE.DARK} />
              ) : (
                <div className='project-navigation__company-action__avatar__placeholder'>
                  {user!.name.slice(0, 2)}
                </div>
              )}
            </div>
          )}
        >
          <div className='user-actions__buttons'>
            <CustomButton
              onClick={openEditProfileModal}
              className='user-actions__general'
              button='add-subtle'
            >
              <EditIcon />
              Edit Profile
            </CustomButton>
            {user &&
            (user.agency_role === Roles.AGENCY_ADMIN || user.agency_role === Roles.SUPER_ADMIN) ? (
              <CustomButton onClick={billing} button='add-subtle'>
                <CardIcon />
                Billing
              </CustomButton>
            ) : null}
            <div className='user-actions__buttons__divide'></div>
            <CustomButton button='add-subtle' onClick={signout}>
              <SignoutIcon />
              Sign Out
            </CustomButton>
          </div>
        </CustomPopup>
        <CustomPopup
          isOpen={true}
          className='user-actions'
          position='right bottom'
          trigger={popupTriggerUserActionsButtonsProject}
          updateTrigger={popupTriggerUserActionsButtonsProject}
        >
          <div className='user-actions__buttons agency'>
            <Can I='manage' an='Agency'>
              <CustomButton
                button='add-subtle'
                className='user-actions__general'
                onClick={() =>
                  moveTo(
                    generatePath((user && [Roles.AGENCY_ADMIN, Roles.SUPER_ADMIN].includes(user.agency_role))?AUTH_ROUTE.GENERAL_SETTINGS:AUTH_ROUTE.NOTIFICATIONS, {
                      projectId: currentProject?.id as number
                    })
                  )
                }
              >
                <SettingsIcon />
                Settings
              </CustomButton>
              <div className='user-actions__buttons__divide'></div>
            </Can>
            {/* <CustomButton button='add-subtle'>
              <img className='user-actions__buttons__icon' src={ScoreIcon} alt='signout' />
              Score
            </CustomButton> */}
            {/* <div className='user-actions__buttons__divide'></div> */}
            <CustomButton button='add-subtle' onClick={signout}>
              <SignoutIcon />
              {/* <img className='user-actions__buttons__icon' src={SignOutIcon} alt='signout' /> */}
              Sign Out
            </CustomButton>
          </div>
        </CustomPopup>
      </div>
    </div>
  )
}

export default SwitchCustomer
